import { render, staticRenderFns } from "./TitleInfo.vue?vue&type=template&id=57317829&scoped=true&"
import script from "./TitleInfo.vue?vue&type=script&lang=ts&"
export * from "./TitleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TitleInfo.vue?vue&type=style&index=0&id=57317829&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57317829",
  null
  
)

export default component.exports